import { CoreModel } from '../core/core.model';
export class GroupQuestionModel extends CoreModel {
/**
 * Group's key
 */
key?: string;
/**
 * Array with group questions
 */
questions?: GroupQuestionModel[];
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function GroupQuestionModel_tsickle_Closure_declarations() {
/**
 * Group's key
 * @type {?}
 */
GroupQuestionModel.prototype.key;
/**
 * Array with group questions
 * @type {?}
 */
GroupQuestionModel.prototype.questions;
}

